export const DATE_FORMAT = "DD.MM.YYYY.";
export const DATE_TIME_FORMAT_LONG = "DD.MM.YYYY. HH:mm:ss";
export const DATE_TIME_FORMAT_SHORT = "DD.MM.YYYY. HH:mm";
export const TIME_FORMAT_SHORT = "HH:mm";
export const ROLE = {
  RegionalAdmin: "RegionalAdmin",
  Admin: "Admin",
  User: "User",
};
export const AUTH_KEY = "authData";
export const TOKEN_LIFETIME = 60;
export const INPUT_TYPE = {
  Checkbox: "checkbox",
  Text: "text",
  Select: "select-one",
};
export const ROUTES = {
  home: "/pocetna",
  privacyPolicy: "/pravila-privatnosti",
  termsAndCond: "/uvjeti-koristenja",
  admin: "/admin",
  verifyEmail: "/potvrdi-email",
  resetPassword: "/resetiraj-lozinku",
  get adminStatistics() {
    return `${this.admin}/statistika`;
  },
  get adminProjects() {
    return `${this.admin}/upiti`;
  },
  get adminUsers() {
    return `${this.admin}/korisnici`;
  },
  get adminUsersActive() {
    return `${this.admin}/korisnici/aktivni`;
  },
  get adminUsersBlocked() {
    return `${this.admin}/korisnici/blokirani`;
  },
  adminUserProjects: "/admin/korisnici/:userId/upiti",
  showAdminUserProjects(userId: number | undefined) {
    return `${this.admin}/korisnici/${userId}/upiti`;
  },
  adminUserProject: "/admin/korisnici/:userId/upit/:projectId",
  showAdminUserProject(userId: number | undefined, projectId: number | undefined) {
    return `${this.admin}/korisnici/${userId}/upit/${projectId}`;
  },
  user: "/korisnik",
  userProfile: "/korisnik/:userId/moj-profil",
  showUserProfile(userId: number | undefined) {
    return `/korisnik/${userId}/moj-profil`;
  },
  userProjects: "/korisnik/:userId/upiti",
  showUserProjects(userId: number | undefined) {
    return `/korisnik/${userId}/upiti`;
  },
  userProject: "/korisnik/:userId/upit/:projectId",
  showUserProject(userId: number | undefined, projectId: number | undefined) {
    return `/korisnik/${userId}/upit/${projectId}`;
  },
};
export const HTTPCODES = {
  Ok: 200,
  BadRequest: 400,
  Unauthorized: 401,
  Forbidden: 403,
  NotFound: 404,
  InternalServerError: 500,
  BadGateway: 502,
  ServiceUnavailable: 503,
};
